import React from "react";
import {classNames} from "@utils/class-names";
import {ReactComponent as CheckmarkIcon} from "@assets/icons/checkmark.svg";
import {Tooltip} from "@common/components/tooltip";

interface ThemeColorOptionProps {
    id: string;
    colorClass: string;
    isSelected: boolean;
    onSelect: () => void;
}

const ThemeColorOption: React.FC<ThemeColorOptionProps> = ({
    id,
    colorClass,
    isSelected,
    onSelect,
}) => {
    const label =
        id.length > 0
            ? id.charAt(0).toUpperCase() + id.slice(1).toLowerCase()
            : "";

    return (
        <Tooltip content={label} position="top">
            <button
                type="button"
                onClick={onSelect}
                className={classNames(
                    "relative h-14 w-14 rounded-[16px] focus:outline-none transition-transform",
                    isSelected && "scale-[1.1]",
                )}
            >
                <span
                    className={classNames(
                        "absolute inset-0 rounded-[16px]",
                        colorClass,
                    )}
                />
                {isSelected && (
                    <span className="absolute inset-0 flex items-center justify-center">
                        <CheckmarkIcon className="h-4 w-4 text-white"/>
                    </span>
                )}
            </button>
        </Tooltip>
    );
};

export default ThemeColorOption;


